module.exports = "<div class=\"row no-gutters row-gutter-color\">\r\n  <div class=\"col-3 right-margin-1\">\r\n    <admin-left-nav></admin-left-nav>\r\n  </div>\r\n  <div class=\"card col left-margin-1\">\r\n    <h1 class=\"section-header\">Admin home</h1>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = main